<template>
    <!-- Plan Free for 30 days -->
    <main class="main  animated fadeIn faster py-0 my-0" :class="{ 'expand-main' : isMenuCollapse }">
        <div class="contenedor py-0 animated fadeIn fast">
          <div class="row  d-flex  flex-row justify-content-center py-0 my-0">
            <div class="col-lg-12 pb-2 text-center py-0">
              <img
                src="@/assets/images/search-oliver3.png"
                class="rounded mx-auto d-block py-0"
                width="180px"
              />
              <h2 class="text-primary font-weight-bold mt-4">
                {{ $t("lang.planfeatures.free_days") }}
              </h2>
              <ul>
                <li class="my-0 py-0">{{ $t("lang.planfeatures.free_days_offer") }}</li>
                <li class="my-2 py-0 font-weight-bold">
                  <div class="row d-flex justify-content-center">
                    <div class="col-12 col-md-5">
                      {{ $t("lang.planfeatures.warn") }}
                    </div>
                  </div>
                </li>
                <li  class="mt-3 py-0 font-weight-bold">{{ $t("lang.planfeatures.free_days_features") }}:</li>
              </ul>
            </div>

            <div class="col-md-12 col-lg-12 col-xl-12 d-flex flex-row justify-content-center">
                <div>
                    <ul class="text-left ">
                        <li class="my-0 py-0">
                            <i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_access") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_csv") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_crm") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_automatic") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_last_time") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_many_times") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_many_times_click") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_many_replies") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_meeting") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_last_meeting") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_first_email") }}
                        </li>
                        <li class="my-0 py-0"><i class="text-primary icon-check1 mr-1"></i>
                            {{ $t("lang.planfeatures.free_days_last_email") }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-5 px-0 my-4">
                <a
                    href="javascript:"
                    @click.prevent="activatePlan()"
                    class="
                      btn btn-block btn-primary
                      themed-button font-weight-bold rounded-2
                    "
                    >{{ $t("lang.planfeatures.free_days_btn_yes") }}</a>
                  <a v-if="cancelButton"
                    href="javascript:"
                    @click.prevent="cancel()"
                    class="
                      btn btn-block btn-outline-dark rounded-2
                    "
                    >{{ $t("lang.planfeatures.free_days_btn_no") }}</a>
              </div>
          </div>
        </div>
    </main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  subscriptionsService,
} from "@/_services";

export default {
    name: 'Promotion',
    data() {
        return {

        };
    },
      props: {
        cancelButton:{
          type:Boolean,
          default:true
        }
      },
    computed: {
        ...mapState({
      isMenuCollapse: state => state.sidebar.isNavOpen,
        }),
    },
    methods:{
      activatePlan(){
          subscriptionsService
                .upgrade(4, 1)
                .then((response) => {
                  const { dispatch } = this.$store;
                  dispatch("authentication/refreshToken").then((response) => {
                    this.$swal({
                      type: "success",
                      title: this.$t("lang.label.great"),
                      text: "",
                      showConfirmButton: false,
                      timer: 3000,
                    }).then((response) => {
                      //this.$router.push("/settings-account?billing=1");
                      window.location.reload();
                    });
                  });
                });
      },

      cancel(){
        let res = true;
        this.$emit('cancel',res);
      }
    }
};
</script>
